import * as Yup from "yup";
import { cnpj, cpf } from "cpf-cnpj-validator";

export const schemaFields = {
  personal: {
    fullName: Yup.string()
      .required("Campo obrigatório")
      .test(
        "surname",
        "Insira o nome completo",
        (value) => String(value).trim().split(" ").length > 1
      ),
    personalEmail: Yup.string()
      .email("Insira um email válido")
      .max(60, "Email excede o limite de caracteres ")
      .required("Campo obrigatório"),
    birthDate: Yup.string().required("Campo obrigatório").nullable(),

    mobile1: Yup.string()
      .required("Campo obrigatório")
      .test(
        "phone",
        "Insira um número válido",
        (value) => value?.replace(/\D/g, "")?.length >= 11
      ),
    personTaxId: Yup.string()
      .when("taxIdType", {
        is: "personTaxId",
        then: Yup.string().test("validTaxId", "Insira um CPF válido", (value) =>
          cpf.isValid(value)
        ),
      })
      .required("Campo obrigatório"),
    // pep: Yup.string(),
    // pepRelationship: Yup.string(),
    maritalStatus: Yup.string().required("Campo obrigatório"),
    gender: Yup.string().required("Campo obrigatório"),
  },
  address: {
    personalZipCode: Yup.string().required("Campo obrigatório"),
    personalState: Yup.string().required("Campo obrigatório"),
    personalCity: Yup.string().required("Campo obrigatório"),
    personalNeighborhood: Yup.string().required("Campo obrigatório"),
    personalStreet: Yup.string().required("Campo obrigatório"),
    personalNumber: Yup.string().required("Campo obrigatório"),
    // complement: Yup.string().required("Campo obrigatório"),
  },
  company: {
    companyEmail: Yup.string()
      .email("Insira um email válido")
      .max(60, "Email excede o limite de caracteres ")
      .required("Campo obrigatório"),
    tradeName: Yup.string().required("Campo obrigatório"),
    taxId: Yup.string()
      .required("Campo obrigatório")
      .test("validTaxId", "Insira um CNPJ válido", (value) =>
        cnpj.isValid(value)
      ),
    constitutionDate: Yup.string().required("Campo obrigatório"),
    companyType: Yup.string().required("Campo obrigatório"),
    cadastralSituation: Yup.string().required("Campo obrigatório"),
    codeActivity: Yup.string().required("Campo obrigatório"),
    // financialEquity: Yup.string().required("Campo obrigatório"),
    // financialProfit: Yup.string().required("Campo obrigatório"),
    zipCode: Yup.string().required("Campo obrigatório"),
    state: Yup.string().required("Campo obrigatório"),
    city: Yup.string().required("Campo obrigatório"),
    neighborhood: Yup.string().required("Campo obrigatório"),
    street: Yup.string().required("Campo obrigatório"),
    number: Yup.string().required("Campo obrigatório"),
    // fatca: Yup.boolean().oneOf([true], "É necessário aceitar os termos"),
  },
  documents: {
    IDENTIFICATION: Yup.object()
      .shape({
        documentFile: Yup.string().required("Campo obrigatório"),
        documentName: Yup.string().required("Campo obrigatório"),
        description: Yup.string().required("Campo obrigatório"),
        documentType: Yup.string().required("Campo obrigatório"),
        documentFormat: Yup.string().required("Campo obrigatório"),
      })
      .nullable()
      .default(null)
      .required("Arquivo obrigatório"),
    SOCIAL_CONTRACT: Yup.object().when("companyType", {
      is: (val) => ["LIMITED", "ME"].includes(val),
      then: Yup.object()
        .shape({
          documentFile: Yup.string().required("Campo obrigatório"),
          documentName: Yup.string().required("Campo obrigatório"),
          description: Yup.string().required("Campo obrigatório"),
          documentType: Yup.string().required("Campo obrigatório"),
          documentFormat: Yup.string().required("Campo obrigatório"),
        })
        .nullable()
        .default(null)
        .required("Arquivo obrigatório"),
    }),
    ENTREPRENEUR_REQUIREMENT: Yup.object().when("companyType", {
      is: "INDIVIDUAL",
      then: Yup.object()
        .shape({
          documentFile: Yup.string().required("Campo obrigatório"),
          documentName: Yup.string().required("Campo obrigatório"),
          description: Yup.string().required("Campo obrigatório"),
          documentType: Yup.string().required("Campo obrigatório"),
          documentFormat: Yup.string().required("Campo obrigatório"),
        })
        .nullable()
        .default(null)
        .required("Arquivo obrigatório"),
    }),
    MINUTES_OF_ELECTION: Yup.object().when("companyType", {
      is: "ASSOCIATION",
      then: Yup.object()
        .shape({
          documentFile: Yup.string().required("Campo obrigatório"),
          documentName: Yup.string().required("Campo obrigatório"),
          description: Yup.string().required("Campo obrigatório"),
          documentType: Yup.string().required("Campo obrigatório"),
          documentFormat: Yup.string().required("Campo obrigatório"),
        })
        .nullable()
        .default(null)
        .required("Arquivo obrigatório"),
    }),
  },

  security: {
    password: Yup.string().required("Campo obrigatório")
    .test("invalid_password", "A senha deve conter 6 números", (value) => {
      return value?.toString().length === 6;
    }),
    confirmPassword: Yup.string()
      .required("Campo obrigatório")
      .oneOf([Yup.ref("password"), null], "As senhas devem ser iguais"),
    terms: Yup.boolean().oneOf([true], "É necessário aceitar os termos"),
    privacyPolicy: Yup.boolean().oneOf(
      [true],
      "É necessário aceitar os termos"
    ),
    termsRepresentation: Yup.boolean().oneOf(
      [true],
      "É necessário aceitar os termos"
    ),
  },
  plan: {
    selectedPlan: Yup.object().required("Escolha um ciclo de assinatura"),
  },
  payment: {
    paymentMethodSelected: Yup.string().required(
      "Escolha um método de pagamento"
    ),
    cardNumber: Yup.string().when("paymentMethodSelected", {
      is: "CREDIT_CARD",
      then: Yup.string().required("Campo obrigatório"),
    }),
    validDate: Yup.string().when("paymentMethodSelected", {
      is: "CREDIT_CARD",
      then: Yup.string()
        .min(7, "Preencha no formato MM/YYYY")
        .required("Campo obrigatório"),
    }),
    holderName: Yup.string().when("paymentMethodSelected", {
      is: "CREDIT_CARD",
      then: Yup.string().required("Campo obrigatório"),
    }),
    securityCode: Yup.string().when("paymentMethodSelected", {
      is: "CREDIT_CARD",
      then: Yup.string().required("Campo obrigatório"),
    }),
  },
};

export const schema = Yup.object().shape({
  ...schemaFields.personal,
  ...schemaFields.address,
  ...schemaFields.company,
  ...schemaFields.documents,
  ...schemaFields.security,
  ...schemaFields.plan,
  ...schemaFields.payment,
});

export const routeProps = {
  0: { name: "Dados pessoais", route: "personal" },
  1: { name: "Endereço", route: "address" },
  2: { name: "Empresa", route: "company" },
  3: { name: "Documentos", route: "documents" },
  4: { name: "Segurança", route: "security" },
  5: { name: "Planos", route: "plan" },
  6: { name: "Pagamento", route: "payment" },
};
